export default "__VITE_ASSET__DO9bPnP$__"